<form (submit)="onSubmit()" [formGroup]="changePasswordForm">
  <app-input-wrapper>
    <label> Old password</label>
    <input
      [type]="showOldPassword ? 'text' : 'password'"
      formControlName="oldPassword"
      placeholder="Enter old password"
    />
    <span
      *ngIf="changePasswordForm.get('oldPassword')?.errors?.['required']&&(changePasswordForm.get('oldPassword')?.dirty||changePasswordForm.get('oldPassword')?.touched)"
    >
      Old password is required
    </span>
    <img
      *ngIf="showOldPassword"
      src="assets/images/eye-close.svg"
      alt="Show"
      (click)="showOldPassword = false"
    />
    <img
      *ngIf="!showOldPassword"
      src="assets/images/eye-open.svg"
      alt="Hide"
      (click)="showOldPassword = true"
    />
  </app-input-wrapper>

  <app-input-wrapper>
    <label>New Password</label>
    <input
      [type]="showNewPassword ? 'text' : 'password'"
      formControlName="newPassword"
      placeholder="Enter new password"
    />
    <span
      *ngIf="changePasswordForm.get('newPassword')?.errors?.['required']&&(changePasswordForm.get('newPassword')?.dirty||changePasswordForm.get('newPassword')?.touched)"
    >
      New password is required
    </span>
    <span
      *ngIf="!changePasswordForm.get('newPassword')?.errors?.['required']&&changePasswordForm.get('newPassword')?.errors?.['minlength']&&(changePasswordForm.get('newPassword')?.dirty||changePasswordForm.get('newPassword')?.touched)"
    >
      Minimum 8 characters required
    </span>
    <img
      *ngIf="showNewPassword"
      src="assets/images/eye-close.svg"
      alt="Show"
      (click)="showNewPassword = false"
    />
    <img
      *ngIf="!showNewPassword"
      src="assets/images/eye-open.svg"
      alt="Hide"
      (click)="showNewPassword = true"
    />
  </app-input-wrapper>
  <app-input-wrapper>
    <label>Confirm password</label>
    <input
      [type]="showConfirmPassword ? 'text' : 'password'"
      formControlName="confirmPassword"
      placeholder="Enter confirm password"
    />
    <span
      *ngIf="changePasswordForm.get('confirmPassword')?.errors?.['required']&&(changePasswordForm.get('confirmPassword')?.dirty||changePasswordForm.get('confirmPassword')?.touched)"
    >
      Confirm password is required
    </span>
    <span
      *ngIf="!changePasswordForm.get('confirmPassword')?.errors?.['required']&&changePasswordForm.get('confirmPassword')?.errors?.['valueMatchErr']&&(changePasswordForm.get('confirmPassword')?.dirty||changePasswordForm.get('confirmPassword')?.touched)"
    >
      Confirm password and new password does not match
    </span>
    <img
      *ngIf="showConfirmPassword"
      src="assets/images/eye-close.svg"
      alt="Show"
      (click)="showConfirmPassword = false"
    />
    <img
      *ngIf="!showConfirmPassword"
      src="assets/images/eye-open.svg"
      alt="Hide"
      (click)="showConfirmPassword = true"
    />
  </app-input-wrapper>

  <div class="flex justify-end">
    <app-button customClass="outline" (action)="handleClose()" label="cancel">
    </app-button>
    <app-button [isDisabled]="isLoading" type="submit" label="Submit">
      <app-button-loader *ngIf="isLoading" postfixContent></app-button-loader>
    </app-button>
  </div>
</form>
